import React from "react";
import { Dropdown, Spin, Typography } from "antd";
import { TrapStatusData } from "../../types";
import AlertDialog from "./AlertDialog";
import "./index.css";
import { useEditTrapMenu } from "../../hooks/useEditTrapMenu";

const { Title } = Typography;

type Props = {
  loading: boolean;
  trapStatusData: TrapStatusData[];
  handleClickDialog: (id: string) => void;
};

const TrapStatus: React.FC<Props> = ({
  loading,
  trapStatusData = [],
  handleClickDialog,
}) => {
  const { menuFor } = useEditTrapMenu();

  return (
    <div className="trap-status-dialog">
      <Spin spinning={loading}>
        <div className="trap-status-dialog-title">
          <Title level={4} className="trap-status-dialog-title-text ">
            Trap Status
          </Title>
        </div>
        <div
          className={`trap-status-dialog-alerts force-show-scrollbars ${
            trapStatusData.length > 0 ? "has-alerts" : "no-alerts"
          }`}
        >
          {trapStatusData.length > 0 &&
            trapStatusData.map((item: TrapStatusData) => (
              // Right-click a trap for Edit Trap. _id here is the device uuid.
              <Dropdown
                key={item._id}
                menu={menuFor(item._id)}
                trigger={["contextMenu"]}
              >
                <div>
                  <AlertDialog item={item} onClick={handleClickDialog} />
                </div>
              </Dropdown>
            ))}
        </div>
      </Spin>
    </div>
  );
};

export default TrapStatus;
